'use client'

import { Store } from '@repo/ui/icons'
import { cn } from '@repo/ui/lib/utils'

export const MarketplaceIcon = ({
  className,
  size = 16,
}: {
  className?: string
  size?: number
}) => (
  <Store
    aria-label={'3PL'}
    className={cn('text-muted-foreground', className)}
    role={'img'}
    size={size}
  data-sentry-element="Store" data-sentry-component="MarketplaceIcon" data-sentry-source-file="marketplace-icon.tsx" />
)
